import DeleteIcon from "@mui/icons-material/DeleteRounded";
import { Avatar, Chip } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  onClick: () => void;
}

export function DeleteAllFiltersChip({ onClick }: Props) {
  const { t } = useTranslation();
  return (
    <Chip
      label={t("clients.deleteAllFilters")}
      onClick={onClick}
      size="medium"
      variant="filled"
      avatar={
        <Avatar alt={t("clients.deleteAllFilters")}>
          <DeleteIcon fontSize="small" sx={{ color: "white !important" }} />
        </Avatar>
      }
    />
  );
}
